import SaleElement from '../AdditionalSales/SaleElement'
import { FormulaSlotContext } from '../AdditionalSales/formulaSlotContext'
import { SaleShellContext } from '../AdditionalSales/saleShellContext'
import ProductPanel from './ProductPanel'
import SaleStatusPanel from './SaleStatusPanel'
import useAdditionalSalesV2Container from './useAdditionalSalesV2Container'
import { SaleGrid, SheetCard, SheetContent, SheetNotices } from './styled-components'

const AdditionalSalesV2Container = () => {
  const {
    t,
    hideComponent,
    activeTab,
    setActiveTab,
    searchValue,
    setSearchValue,
    products,
    poles,
    pole,
    countOf,
    changePole,
    setFormulaList,
    setNotice,
    showSale,
    sheetLabel,
    salePath,
    vaType,
    formulaSlots,
  } = useAdditionalSalesV2Container()

  if (hideComponent) return null

  return (
    <SaleGrid>
      <ProductPanel
        t={t}
        products={products}
        activeTab={activeTab}
        onSelect={setActiveTab}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        formulaSlotRef={setFormulaList}
        poles={poles}
        pole={pole}
        onSelectPole={changePole}
        countOf={countOf}
      />
      {showSale && (
        <>
          <SheetCard aria-label={sheetLabel}>
            <SheetContent key={activeTab}>
              <SheetNotices ref={setNotice} />
              <SaleShellContext.Provider value={true}>
                <FormulaSlotContext.Provider value={formulaSlots}>
                  <SaleElement path={salePath} vaType={vaType} isBlockedIfMcpCreated={false} />
                </FormulaSlotContext.Provider>
              </SaleShellContext.Provider>
            </SheetContent>
          </SheetCard>
          <SaleShellContext.Provider value={true}>
            <SaleStatusPanel key={activeTab} saleType={activeTab} />
          </SaleShellContext.Provider>
        </>
      )}
    </SaleGrid>
  )
}

export default AdditionalSalesV2Container
